<span class="task-badge" [attr.data-variant]="presentation().variant"
    [ngbTooltip]="presentation().tooltip" container="body">
    <i class="fa-solid" [class]="presentation().icon" aria-hidden="true"></i>
    <!-- The icon is decorative; this is what keeps the row's accessible name saying what kind of
         operation it is. -->
    <span class="visually-hidden">{{ presentation().label }}</span>
</span>
